import en from './languages/en';
import ru from './languages/ru';

const FALLBACK_LANG = 'en';

const dict = { en, ru };
const loading = new Map();
const loaders = {
  de: () => import('./languages/de').then((m) => m.default),
  fr: () => import('./languages/fr').then((m) => m.default),
  es: () => import('./languages/es').then((m) => m.default),
  pt: () => import('./languages/pt').then((m) => m.default),
  it: () => import('./languages/it').then((m) => m.default),
  pl: () => import('./languages/pl').then((m) => m.default),
  ko: () => import('./languages/ko').then((m) => m.default),
};

function getLanguageCode() {
  if (typeof window === 'undefined') return 'ru';
  const code = localStorage.getItem('bibleLanguage') || 'ru';
  return code.toLowerCase();
}

/** Сообщить слушателям (например, чату), что сменился язык UI или подгрузился языковой пакет. */
export function notifyLocaleChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('verbum:locale-updated'));
}

export function t(key) {
  const lang = getLanguageCode();
  if (!dict[lang] && loaders[lang]) {
    void ensureLanguageLoaded(lang);
  }
  const langDict = dict[lang] || dict[FALLBACK_LANG];
  const primary = langDict?.[key];
  if (primary !== undefined && primary !== '') return primary;
  const enVal = dict[FALLBACK_LANG][key];
  if (enVal !== undefined && enVal !== '') return enVal;
  return key;
}

/**
 * Строка с числом и правильной формой слова: ищет `${key}_one|_few|_many|_other`
 * по Intl.PluralRules языка, иначе берёт `key`. `{count}` подставляется.
 */
export function tCount(key, count) {
  const lang = getLanguageCode();
  let category = 'other';
  try {
    category = new Intl.PluralRules(lang).select(Number(count) || 0);
  } catch {
    /* старый браузер без PluralRules */
  }
  const own = (dict[lang] || dict[FALLBACK_LANG])?.[`${key}_${category}`];
  return (own || t(key)).replace('{count}', String(count));
}

export async function ensureLanguageLoaded(langCode) {
  const lang = String(langCode || '').toLowerCase();
  if (!lang || dict[lang]) return dict[lang] || null;
  const load = loaders[lang];
  if (!load) return null;

  if (!loading.has(lang)) {
    loading.set(
      lang,
      load()
        .then((messages) => {
          dict[lang] = messages || {};
          notifyLocaleChanged();
          return dict[lang];
        })
        .catch(() => null)
    );
  }

  return loading.get(lang);
}

export function formatDateTime(ts) {
  const lang = getLanguageCode();
  return new Date(ts).toLocaleDateString(lang, {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

